import { AtSign } from 'lucide-react';
import { DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Card } from '@/components/ui/card';
import { AccountTable } from './AccountTable';
import { AddSenderForm } from './AddSenderForm';
import type { EmailAccount, SelectedDomain } from './types';

interface AccountSetupStepProps {
  variant?: 'modal' | 'page';
  selectedDomains: SelectedDomain[];
  accounts: EmailAccount[];
  onAddSender: (username: string, domain: string, firstName: string, lastName: string) => void;
  onRemoveAccount: (accountId: string) => void;
}

const ACCOUNT_PRICE_CENTS = 700; // $7
const MAX_ACCOUNTS_PER_DOMAIN = 3;

export function AccountSetupStep({
  variant = 'modal',
  selectedDomains,
  accounts,
  onAddSender,
  onRemoveAccount,
}: AccountSetupStepProps) {
  const header = variant === 'modal' ? (
    <DialogHeader className="pt-0">
      <div className="flex items-center gap-3 mt-1">
        <AtSign className="h-8 w-8 flex-shrink-0" />
        <div>
          <DialogTitle>Configure Email Accounts</DialogTitle>
          <DialogDescription className="mt-1">
            Set up email accounts for your selected domains
          </DialogDescription>
        </div>
      </div>
    </DialogHeader>
  ) : null;

  const content = (
    <div className="space-y-6">
      <AddSenderForm domains={selectedDomains} accounts={accounts} onAddSender={onAddSender} />

      <AccountTable
        accounts={accounts}
        onRemoveAccount={onRemoveAccount}
        accountPrice={ACCOUNT_PRICE_CENTS}
      />
    </div>
  );

  if (variant === 'page') {
    return (
      <Card className="p-6">
        <AddSenderForm domains={selectedDomains} accounts={accounts} onAddSender={onAddSender} />
      </Card>
    );
  }

  return (
    <>
      {header}
      <div className="pt-6 pb-2">{content}</div>
    </>
  );
}

export { MAX_ACCOUNTS_PER_DOMAIN };
